import { RouteType } from "types/routes.types";
import {
  CheckSquareOutlined,
  ControlOutlined,
  HomeOutlined,
  InboxOutlined,
  MonitorOutlined,
  ScheduleOutlined,
  UserOutlined,
  CalendarOutlined,
  GiftOutlined,
} from "@ant-design/icons";
import TicketIcon from "assets/icons/TicketIcon";

import App from "views/App";
import DataControl from "views/App/views/DataControl";
import Tickets from "views/App/views/Tickets";
import Monitoring from "views/App/views/Monitoring";
import Reporting from "views/App/views/Reporting";
import Shipping from "views/App/views/Shipping";
import UserInfo from "views/App/views/UserInfo";
import { Roles } from "types/user.types";
import DatesManagement from "views/App/views/DatesManagement";
import ActivateReserves from "views/App/views/ActivateReserves";
import IncentiveManagement from "views/App/views/IncentiveManagement";

export const appRoutes: RouteType[] = [
  {
    name: "menu.home",
    path: "/",
    Element: App,
    Icon: HomeOutlined,
  },
  {
    name: "menu.search",
    path: "/suche",
    Element: DataControl,
    Icon: ControlOutlined,
    authority: [
      Roles.LinkPL,
      Roles.LinkFeldleitung,
      Roles.LinkAdmin,
      Roles.LinkAgent,
      Roles.AgroscopePL,
      Roles.FachlicheHotline,
    ],
  },
  {
    name: "menu.tickets",
    path: "fromAPI",
    Element: Tickets,
    Icon: TicketIcon,
    external: true,
  },
  {
    name: "menu.monitoring",
    path: "/monitoring",
    Element: Monitoring,
    Icon: MonitorOutlined,
    authority: [
      Roles.LinkPL,
      Roles.LinkFeldleitung,
      Roles.LinkAdmin,
      Roles.AgroscopePL,
      Roles.FachlicheHotline,
    ],
  },
  {
    name: "menu.reporting",
    path: "/reporting",
    Element: Reporting,
    Icon: ScheduleOutlined,
    authority: [
      Roles.LinkPL,
      Roles.LinkFeldleitung,
      Roles.LinkAdmin,
      Roles.AgroscopePL,
    ],
  },
  {
    name: "menu.versand",
    path: "https://ldcsalpha-uat.link.ch/hotline/107479000/dispatch",
    productionPath: "https://ldcsalpha.link.ch/hotline/107479000/dispatch",
    Element: Shipping,
    Icon: InboxOutlined,
    external: true,
    authority: [Roles.LinkITOperations],
  },
  {
    name: "menu.user",
    path: "/user",
    Element: UserInfo,
    Icon: UserOutlined,
    hideInMenu: true,
  },
  {
    name: "menu.activateReserves",
    path: "/reserven-aktivieren",
    Element: ActivateReserves,
    Icon: CheckSquareOutlined,
    authority: [Roles.LinkPL, Roles.LinkAdmin],
  },
  {
    name: "menu.datesManagement",
    path: "/datum-management",
    Element: DatesManagement,
    Icon: CalendarOutlined,
    authority: [Roles.LinkPL, Roles.LinkAdmin],
  },
  {
    name: "menu.incentiveManagement",
    path: "/incentiveManagement",
    Element: IncentiveManagement,
    Icon: GiftOutlined,
    authority: [Roles.LinkPL, Roles.LinkAdmin],
  },
];
